module.exports = __webpack_public_path__ + "img/logo-menu-light.a6f344df.png";